/* ==========================================================================
   MISSION TIRANGA — interactions
   Vanilla JS only. No external libraries. All animations CSS-driven where
   possible; JS limited to triggers, small state, and light DOM writes.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('mt-root');
  if (!root) return;

  /* ------------------------------------------------------------------
     Utility
     ------------------------------------------------------------------ */
  function rand(min, max) { return Math.random() * (max - min) + min; }
  function qs(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------
     1. Generate starfield (hero + about visual) — pure DOM, CSS animated
     ------------------------------------------------------------------ */
  function buildStarfield(container, count, shootingStars) {
    if (!container) return;
    var frag = document.createDocumentFragment();

    for (var i = 0; i < count; i++) {
      var star = document.createElement('span');
      star.className = 'mt-star';
      var size = rand(1, 2.6);
      star.style.width = size + 'px';
      star.style.height = size + 'px';
      star.style.top = rand(0, 100) + '%';
      star.style.left = rand(0, 100) + '%';
      star.style.animationDelay = rand(0, 3) + 's';
      star.style.animationDuration = rand(2.4, 4.2) + 's';
      frag.appendChild(star);
    }

    // a few soft glowing particles in brand colours
    var colors = ['#FF7A1A', '#128C4A', '#FFFFFF'];
    for (var p = 0; p < Math.round(count / 6); p++) {
      var particle = document.createElement('span');
      particle.className = 'mt-particle';
      var ps = rand(3, 7);
      particle.style.width = ps + 'px';
      particle.style.height = ps + 'px';
      particle.style.top = rand(0, 100) + '%';
      particle.style.left = rand(0, 100) + '%';
      particle.style.background = colors[p % colors.length];
      particle.style.filter = 'blur(1px)';
      particle.style.animationDelay = rand(0, 5) + 's';
      particle.style.animationDuration = rand(6, 10) + 's';
      frag.appendChild(particle);
    }

    if (shootingStars) {
      for (var s = 0; s < 3; s++) {
        var shoot = document.createElement('span');
        shoot.className = 'mt-shooting-star';
        shoot.style.top = rand(5, 45) + '%';
        shoot.style.left = rand(50, 90) + '%';
        shoot.style.animationDelay = rand(0, 6) + 's';
        frag.appendChild(shoot);
      }
    }

    container.appendChild(frag);
  }

  buildStarfield(document.getElementById('mtHeroStars'), 110, true);
  qsa('.mt-about-visual .mt-space-bg').forEach(function (el) {
    buildStarfield(el, 30, false);
  });

  /* ------------------------------------------------------------------
     2. Scroll progress bar
     ------------------------------------------------------------------ */
  var progressBar = document.getElementById('mtProgress');
  function updateProgress() {
    if (!progressBar) return;
    var doc = document.documentElement;
    var scrollTop = window.scrollY || doc.scrollTop;
    var height = doc.scrollHeight - doc.clientHeight;
    var pct = height > 0 ? (scrollTop / height) * 100 : 0;
    progressBar.style.width = pct + '%';
  }

  /* ------------------------------------------------------------------
     3. Sticky mobile CTA visibility (after hero passed)
     ------------------------------------------------------------------ */
  var stickyCta = document.getElementById('mtStickyCta');
  var hero = document.getElementById('mtHero');
  var registerSection = document.getElementById('mtRegisterSection');

  function updateStickyCta() {
    if (!stickyCta || !hero) return;
    var heroBottom = hero.getBoundingClientRect().bottom;
    var pastHero = heroBottom < 0;

    var hideNearForm = false;
    if (registerSection) {
      var r = registerSection.getBoundingClientRect();
      hideNearForm = r.top < window.innerHeight * 0.5 && r.bottom > 0;
    }

    if (pastHero && !hideNearForm) {
      stickyCta.classList.add('mt-is-visible');
    } else {
      stickyCta.classList.remove('mt-is-visible');
    }
  }

  var scrollTicking = false;
  window.addEventListener('scroll', function () {
    if (!scrollTicking) {
      window.requestAnimationFrame(function () {
        updateProgress();
        updateStickyCta();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  updateProgress();
  updateStickyCta();

  /* ------------------------------------------------------------------
     4. Scroll-triggered reveal animations
     ------------------------------------------------------------------ */
  var revealEls = qsa('.mt-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('mt-is-visible'); });
  }

  /* ------------------------------------------------------------------
     5. Smooth scroll for CTA buttons ("Secure Your Spot" etc.)
     ------------------------------------------------------------------ */
  qsa('[data-scroll-to]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('data-scroll-to');
      var target = document.getElementById(targetId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ------------------------------------------------------------------
     6. Magnetic button effect (desktop pointer only)
     ------------------------------------------------------------------ */
  var isFinePointer = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  if (isFinePointer) {
    qsa('.mt-magnetic').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = 'translate(' + (x * 0.18) + 'px,' + (y * 0.35) + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  /* ------------------------------------------------------------------
     7. 3D tilt on mission cards (desktop pointer only)
     ------------------------------------------------------------------ */
  if (isFinePointer) {
    qsa('.mt-tilt-card').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        var rotateX = (0.5 - py) * 10;
        var rotateY = (px - 0.5) * 10;
        card.style.transform = 'perspective(700px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  /* ------------------------------------------------------------------
     8. Payment screenshot upload — preview + drag & drop
     ------------------------------------------------------------------ */
  var uploadBox = document.getElementById('mtUploadBox');
  var uploadInput = document.getElementById('mtPaymentProof');
  var uploadFilename = document.getElementById('mtUploadFilename');

  if (uploadBox && uploadInput) {
    uploadBox.addEventListener('click', function () { uploadInput.click(); });

    uploadInput.addEventListener('change', function () {
      if (uploadInput.files && uploadInput.files[0]) {
        uploadFilename.textContent = '✓ ' + uploadInput.files[0].name;
      } else {
        uploadFilename.textContent = '';
      }
    });

    ['dragenter', 'dragover'].forEach(function (evt) {
      uploadBox.addEventListener(evt, function (e) {
        e.preventDefault();
        uploadBox.classList.add('mt-is-dragover');
      });
    });
    ['dragleave', 'drop'].forEach(function (evt) {
      uploadBox.addEventListener(evt, function (e) {
        e.preventDefault();
        uploadBox.classList.remove('mt-is-dragover');
      });
    });
    uploadBox.addEventListener('drop', function (e) {
      var files = e.dataTransfer.files;
      if (files && files[0]) {
        uploadInput.files = files;
        uploadFilename.textContent = '✓ ' + files[0].name;
      }
    });
  }

  /* ------------------------------------------------------------------
     9. Toast helper
     ------------------------------------------------------------------ */
  var toastEl = document.getElementById('mtToast');
  var toastTimer = null;
  function showToast(message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.add('mt-is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('mt-is-visible');
    }, 3200);
  }

  /* ------------------------------------------------------------------
     10. Registration form — client-side validation
     NOTE: This submits to Shopify's native contact form endpoint.
     Actual email delivery to dhanalakshmi.k@subhanu.com and file-upload
     handling requires a backend integration (Shopify Flow / form app /
     webhook) — see comment in the .liquid section. This script only
     validates fields, gives UX feedback, and lets the native submit proceed.
     ------------------------------------------------------------------ */
  var form = document.getElementById('mtRegisterForm');
  var submitBtn = document.getElementById('mtSubmitBtn');
  var successPanel = document.getElementById('mtSuccessPanel');

  var validators = {
    mtParentName: function (v) { return v.trim().length > 1 || 'Please enter the parent\'s name.'; },
    mtChildName: function (v) { return v.trim().length > 1 || 'Please enter the child\'s name.'; },
    mtChildAge: function (v) {
      var n = parseInt(v, 10);
      return (n >= 8 && n <= 14) || 'Age must be between 8 and 14.';
    },
    mtEmail: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Enter a valid email address.'; },
    mtMobile: function (v) { return /^[0-9+\-\s]{7,15}$/.test(v) || 'Enter a valid mobile number.'; },
    mtEmergency: function (v) { return /^[0-9+\-\s]{7,15}$/.test(v) || 'Enter a valid emergency contact number.'; },
    mtCity: function (v) { return v.trim().length > 1 || 'Please enter a city.'; },
    mtState: function (v) { return v.trim().length > 1 || 'Please enter a state.'; },
    mtParticipants: function (v) { return v !== '' || 'Please select number of participants.'; }
  };

  function setFieldError(fieldId, message) {
    var errEl = form.querySelector('[data-error-for="' + fieldId + '"]');
    var inputEl = document.getElementById(fieldId);
    if (errEl) errEl.textContent = message || '';
    if (inputEl) {
      if (message) inputEl.classList.add('mt-input--error');
      else inputEl.classList.remove('mt-input--error');
    }
  }

  function validateForm() {
    var valid = true;
    Object.keys(validators).forEach(function (fieldId) {
      var el = document.getElementById(fieldId);
      if (!el) return;
      var result = validators[fieldId](el.value || '');
      if (result === true) {
        setFieldError(fieldId, '');
      } else {
        setFieldError(fieldId, result);
        valid = false;
      }
    });
    return valid;
  }

  if (form) {
    // live-clear errors as the user types/selects
    Object.keys(validators).forEach(function (fieldId) {
      var el = document.getElementById(fieldId);
      if (!el) return;
      el.addEventListener('input', function () { setFieldError(fieldId, ''); });
      el.addEventListener('change', function () { setFieldError(fieldId, ''); });
    });

    form.addEventListener('submit', function (e) {
      var isValid = validateForm();

      if (!isValid) {
        e.preventDefault();
        showToast('Please fix the highlighted fields.');
        var firstError = form.querySelector('.mt-input--error');
        if (firstError) firstError.focus();
        return;
      }

      // Valid: let the native Shopify contact-form submission proceed.
      // We optimistically show the success panel; the actual confirmation
      // + emailing to dhanalakshmi.k@subhanu.com depends on the backend
      // integration described in the code comments.
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';

      // Give the UI a brief moment before native navigation/submit occurs.
      setTimeout(function () {
        if (successPanel) {
          form.style.display = 'none';
          successPanel.classList.add('mt-is-active');
        }
      }, 300);
    });
  }

  /* ------------------------------------------------------------------
     11. Mouse-reactive parallax on hero orbit stage (desktop only)
     ------------------------------------------------------------------ */
  var orbitStage = qs('.mt-hero-orbit-stage');
  if (isFinePointer && orbitStage && hero) {
    hero.addEventListener('mousemove', function (e) {
      var rect = hero.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      orbitStage.style.transform = 'translate(' + (x * 16) + 'px,' + (y * 16) + 'px)';
    });
    hero.addEventListener('mouseleave', function () {
      orbitStage.style.transform = '';
    });
  }

  /* ------------------------------------------------------------------
     12. Scroll-based parallax on hero — Earth/orbit stage drifts and
     fades gently as the visitor scrolls past, on every device (not just
     pointer-driven), for a sense of depth as the page moves.
     ------------------------------------------------------------------ */
  if (orbitStage && hero) {
    var heroNebulas = qsa('.mt-hero-nebula');
    window.addEventListener('scroll', function () {
      var rect = hero.getBoundingClientRect();
      var progress = Math.min(Math.max(-rect.top / (rect.height || 1), 0), 1);
      orbitStage.style.opacity = String(1 - progress * 0.6);
      var parallaxY = progress * 60;
      orbitStage.style.marginTop = (-parallaxY) + 'px';
      heroNebulas.forEach(function (n, i) {
        n.style.transform = 'translateY(' + (progress * (24 + i * 10)) + 'px)';
      });
    }, { passive: true });
  }

  /* ------------------------------------------------------------------
     13. Previous Workshops — click-to-play video cards. Native controls
     are switched off in the Liquid template in favour of the custom
     circular play button; this wires the whole card up as the trigger.
     ------------------------------------------------------------------ */
  var galleryCards = qsa('.mt-gallery-card');
  galleryCards.forEach(function (card) {
    var video = qs('video', card);
    if (!video) return;
    video.setAttribute('playsinline', '');
    card.classList.add('mt-has-video');

    card.addEventListener('click', function () {
      if (video.paused || video.ended) {
        galleryCards.forEach(function (other) {
          var otherVideo = qs('video', other);
          if (otherVideo && otherVideo !== video && !otherVideo.paused) {
            otherVideo.pause();
            other.classList.remove('mt-is-playing');
          }
        });
        video.play();
        card.classList.add('mt-is-playing');
      } else {
        video.pause();
        card.classList.remove('mt-is-playing');
      }
    });
    video.addEventListener('ended', function () { card.classList.remove('mt-is-playing'); });
  });

  /* ------------------------------------------------------------------
     14. About Workshop visual — Interactive Satellite Explorer.
     Real drag-to-rotate (pointer events, inertia) on a CSS 3D rig,
     click-to-select parts with a sliding info panel, an exploded/
     assembled toggle, and an optional mission challenge.

     No 3D library: the rig is built from independently-positioned 2D
     layers inside a CSS perspective stage (transform-style: preserve-3d
     + translateZ per part), which gives real drag-driven parallax
     without the size of Three.js/WebGL. There was no existing 3D model
     asset for this satellite (only a flat SVG illustration) — building
     and rigging one from scratch would be a large, disproportionate
     undertaking for a single product-page component, and isn't needed
     to satisfy "drag to rotate" + "explode into parts", which this
     layered-CSS approach delivers directly.
     ------------------------------------------------------------------ */
  var missionVisual = qs('.mt-about-visual[data-mission-root]');
  if (missionVisual) {
    var stage = qs('#mtSatStage', missionVisual);
    var rig = qs('#mtSatRig', missionVisual);
    var explodeBtn = qs('#mtExplodeToggle', missionVisual);
    var infoPanel = qs('#mtPartInfo', missionVisual);
    var infoClose = qs('#mtPartInfoClose', missionVisual);
    var challengeEl = qs('#mtChallenge', missionVisual);
    var prefersReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    var PARTS = {
      body:    { icon: '🛰️', title: 'Main Body', role: 'Control System', desc: 'Contains the systems that keep the satellite operating in orbit.' },
      solar:   { icon: '☀️', title: 'Solar Panels', role: 'Power', desc: 'Converts sunlight into electrical energy for the satellite.', widget: 'power' },
      antenna: { icon: '📡', title: 'Communication Antenna', role: 'Communication', desc: 'Sends and receives signals between the satellite and Earth.', widget: 'comm' },
      payload: { icon: '🧪', title: 'Payload', role: 'Mission Equipment', desc: 'The equipment the satellite carries to perform its mission.' },
      power:   { icon: '🔋', title: 'Power System', role: 'Energy Storage', desc: 'Stores and distributes electrical power to every system on board.' }
    };

    /* ---------------- Drag to rotate, with inertia ---------------- */
    var hasInteracted = false;
    function markInteracted() {
      if (hasInteracted || !stage) return;
      hasInteracted = true;
      stage.classList.add('mt-has-interacted');
    }

    if (rig && stage) {
      var rotX = -6, rotY = -18;
      var velX = 0, velY = 0;
      var dragging = false;
      var lastX = 0, lastY = 0, lastT = 0;
      var inertiaRaf = null;

      function applyRotation() {
        rig.style.setProperty('--rig-rx', rotX + 'deg');
        rig.style.setProperty('--rig-ry', rotY + 'deg');
      }
      applyRotation();

      function clampX(v) { return Math.max(-20, Math.min(20, v)); }
      function stopInertia() {
        if (inertiaRaf) { cancelAnimationFrame(inertiaRaf); inertiaRaf = null; }
      }
      function runInertia() {
        stopInertia();
        if (prefersReducedMotion || (Math.abs(velX) < 0.02 && Math.abs(velY) < 0.02)) return;
        function step() {
          velX *= 0.94;
          velY *= 0.94;
          rotY += velX;
          rotX = clampX(rotX + velY);
          applyRotation();
          if (Math.abs(velX) > 0.02 || Math.abs(velY) > 0.02) {
            inertiaRaf = requestAnimationFrame(step);
          } else {
            inertiaRaf = null;
          }
        }
        inertiaRaf = requestAnimationFrame(step);
      }

      function onPointerDown(e) {
        dragging = true;
        stopInertia();
        lastX = e.clientX; lastY = e.clientY; lastT = performance.now();
        velX = 0; velY = 0;
        rig.classList.add('is-dragging');
        if (stage.setPointerCapture && e.pointerId != null) {
          try { stage.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
        }
      }
      function onPointerMove(e) {
        if (!dragging) return;
        var now = performance.now();
        var dx = e.clientX - lastX;
        var dy = e.clientY - lastY;
        var dt = Math.max(1, now - lastT);
        var stepY = dx * 0.28;
        var stepX = -dy * 0.18;
        rotY += stepY;
        rotX = clampX(rotX + stepX);
        velX = stepY / (dt / 16);
        velY = stepX / (dt / 16);
        lastX = e.clientX; lastY = e.clientY; lastT = now;
        applyRotation();
        if (Math.abs(dx) > 2 || Math.abs(dy) > 2) markInteracted();
      }
      function onPointerUp() {
        if (!dragging) return;
        dragging = false;
        rig.classList.remove('is-dragging');
        runInertia();
      }

      stage.addEventListener('pointerdown', onPointerDown);
      stage.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', onPointerUp);
      window.addEventListener('pointercancel', onPointerUp);

      /* Keyboard: arrow keys rotate when the stage itself has focus */
      stage.addEventListener('keydown', function (e) {
        var handled = true;
        if (e.key === 'ArrowLeft') { rotY -= 8; }
        else if (e.key === 'ArrowRight') { rotY += 8; }
        else if (e.key === 'ArrowUp') { rotX = clampX(rotX - 6); }
        else if (e.key === 'ArrowDown') { rotX = clampX(rotX + 6); }
        else { handled = false; }
        if (handled) {
          e.preventDefault();
          stopInertia();
          applyRotation();
          markInteracted();
        }
      });
    }

    /* ---------------- Part selection + sliding info panel ---------------- */
    var parts = qsa('.mt-part', missionVisual);
    var activePartKey = null;

    function closeInfoPanel() {
      if (!infoPanel) return;
      infoPanel.classList.remove('is-open');
      parts.forEach(function (p) { p.classList.remove('is-selected'); });
      qsa('.mt-hotspot-dot', missionVisual).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      activePartKey = null;
    }

    function playCommAnimation() {
      var statusEl = qs('[data-comm-status]', infoPanel);
      if (!statusEl) return;
      statusEl.textContent = 'Signal Transmitting…';
      window.setTimeout(function () {
        if (activePartKey === 'antenna') statusEl.textContent = 'Signal Received ✓';
      }, 1100);
    }
    function playPowerAnimation() {
      var fill = qs('[data-power-fill]', infoPanel);
      var value = qs('[data-power-value]', infoPanel);
      if (!fill || !value) return;
      fill.style.width = '0%';
      value.textContent = '0%';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { fill.style.width = '92%'; });
      });
      var start = performance.now();
      function step(now) {
        var t = Math.min(1, (now - start) / 900);
        value.textContent = Math.round(92 * t) + '%';
        if (t < 1 && activePartKey === 'solar') requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    function openPartInfo(key, btn) {
      var data = PARTS[key];
      if (!data || !infoPanel) return;
      activePartKey = key;

      var iconEl = qs('[data-part-icon]', infoPanel);
      var titleEl = qs('[data-part-title]', infoPanel);
      var roleEl = qs('[data-part-role]', infoPanel);
      var descEl = qs('[data-part-desc]', infoPanel);
      if (iconEl) iconEl.textContent = data.icon;
      if (titleEl) titleEl.textContent = data.title;
      if (roleEl) roleEl.textContent = data.role;
      if (descEl) descEl.textContent = data.desc;

      qsa('.mt-part-info-widget', infoPanel).forEach(function (w) { w.classList.remove('is-active'); });
      if (data.widget) {
        var widget = qs('[data-widget="' + data.widget + '"]', infoPanel);
        if (widget) widget.classList.add('is-active');
        if (data.widget === 'comm') playCommAnimation();
        if (data.widget === 'power') playPowerAnimation();
      }

      parts.forEach(function (p) {
        p.classList.toggle('is-selected', p.getAttribute('data-part') === key);
      });
      qsa('.mt-hotspot-dot', missionVisual).forEach(function (b) { b.setAttribute('aria-expanded', String(b === btn)); });

      infoPanel.classList.add('is-open');
      checkChallenge(key);
    }

    qsa('[data-hotspot]', missionVisual).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var part = btn.closest ? btn.closest('.mt-part') : null;
        var key = part && part.getAttribute('data-part');
        if (!key) return;
        if (activePartKey === key && infoPanel && infoPanel.classList.contains('is-open')) {
          closeInfoPanel();
        } else {
          openPartInfo(key, btn);
        }
        markInteracted();
      });
    });
    infoClose && infoClose.addEventListener('click', function (e) { e.stopPropagation(); closeInfoPanel(); });
    document.addEventListener('click', function (e) {
      if (infoPanel && infoPanel.classList.contains('is-open') && !infoPanel.contains(e.target)) closeInfoPanel();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeInfoPanel(); });

    /* ---------------- Explore Parts / Assemble Satellite ---------------- */
    if (explodeBtn && rig) {
      explodeBtn.addEventListener('click', function () {
        var exploded = rig.classList.toggle('is-exploded');
        explodeBtn.setAttribute('aria-pressed', String(exploded));
        markInteracted();
      });
    }

    /* ---------------- Optional mission challenge ---------------- */
    var challengeSequence = ['antenna', 'power', 'solar'];
    var challengeIndex = 0;
    var challengeLabels = {
      antenna: 'the communication system',
      power: 'the power system',
      solar: 'the solar panels',
      body: 'the main body',
      payload: 'the payload'
    };
    function setChallengePrompt() {
      if (!challengeEl) return;
      var target = challengeSequence[challengeIndex % challengeSequence.length];
      challengeEl.setAttribute('data-challenge-target', target);
      var promptEl = qs('[data-challenge-prompt]', challengeEl);
      var resultEl = qs('[data-challenge-result]', challengeEl);
      if (promptEl) promptEl.textContent = 'Find ' + challengeLabels[target] + '.';
      if (resultEl) { resultEl.textContent = ''; resultEl.classList.remove('is-visible'); }
    }
    function checkChallenge(key) {
      if (!challengeEl) return;
      var target = challengeEl.getAttribute('data-challenge-target');
      if (!target || key !== target) return;
      var resultEl = qs('[data-challenge-result]', challengeEl);
      if (!resultEl) return;
      resultEl.textContent = '✓ System Identified — +10 Mission Points';
      resultEl.classList.add('is-visible');
      window.setTimeout(function () {
        challengeIndex++;
        setChallengePrompt();
      }, 2200);
    }
    setChallengePrompt();
  }

})();